module.exports = __webpack_public_path__ + "img/contact.de8a42c5.jpg";